<template>
<div class="chapter">
<div class="inner_page">
<p class="normal-d">The wrath of the lion<br/>is the wisdom of God.<br/>—William Blake (<i>Proverbs of Hell</i>)</p>
<p class="normal-d1">Wednesday’s child is full of woe,<br/>Thursday’s child has far to go.<br/>—Nursery Rhyme</p>
<p class="normal-d1">The wrath of the lion<br/>may see me through Wednesday<br/>But where the hell do I go<br/>after that?<br/>—Mack Bolan, the Executioner</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?f0c1c2a6